// extracted by mini-css-extract-plugin
export default {"vips":"vips_vips__iBU+l","header":"vips_header__2fyiY","body":"vips_body__-HN5a"};